import { render } from "./PasswordReset.vue?vue&type=template&id=4ba6c536&bindings={\"isValidSession\":\"data\",\"username\":\"data\",\"code\":\"data\",\"expired\":\"data\",\"password\":\"data\",\"password2\":\"data\",\"resetError\":\"data\",\"resetSuccess\":\"data\",\"checkValidSession\":\"options\",\"submitReset\":\"options\"}"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"
script.render = render

export default script